module.exports = __webpack_public_path__ + "img/trash.5a226e36.svg";